module.exports = __webpack_public_path__ + "assets/26bbcd3e8037c5a7bf5bbb1ef5570dad.png";